import React, { Component } from 'react';
import CloseIcon from "@material-ui/icons/Close";
import './PaymentProcess.scss'
import '../../../index.scss'
import moment from 'moment';
import { Dialog, DialogContent, FormControl, RadioGroup, FormControlLabel, Radio } from '@material-ui/core';
import { getSecureItem } from '../../../utilsFunctions';
import { withRouter } from 'react-router-dom/cjs/react-router-dom';
import Select from "react-select";
import axios from 'axios';
import { BaseUrl, ImageBaseUrl } from '../../../Environment';
import { getCompanyProfile } from '../../../api';
import { fetchAPIData, getAllBankAccountsDataAPI } from '../../../service/service';

class PaymentProcess extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            bankAccountData: [],
            overPaymentType: "",
            whenNotPaid: "",
            step2: false,
            step3: false,
            replanPenalty: 0,
            mode: 'full',
            notPaidReason: '',
            readOnly: true,
            totalAmount: 0,
            backupTotalAmount: 0,
            loanBalanceAmount:0,
            penalty: 0,
            calculationType: 'perDay',
            penaltyType: '',
            penaltyValue: 0,
            penaltyToPay: 0,
            backupPenalty: 0,
            selectedValue: 'cash',
            collectionAmount: 0,
            minPenalty: 0,
            isPartialPay: false,
            isDisabled: false,
            isAmountInvalid: false,
            isPenaltyInvalid: false,
            isNotPaidReasonInvalid: false,
            isReceive: true,
            isPayModeInvalid: false,
            isPayTypeOther: false,
            otherMode: '',
            isPayTypeCheque: false,
            countryCurrency: {},
            date:new Date().toISOString().split('T')[0],            
        };
    }

    //reset the values
    resetValues = () => {

        this.setState({
            overPaymentType: "reduceTenure",
            mode: 'full',
            isPartialPay: false,
            readOnly: true,
            totalAmount: 0,
            backupTotalAmount: 0,
            loanBalanceAmount:0,
            penalty: 0,
            selectedValue: this.props?.isFromLink ? 'payLink' : 'cash',
            collectionAmount: 0,
            minPenalty: 0,
            date:new Date().toISOString().split('T')[0],
            isDisabled: false,
            isAmountInvalid: false,
            isPenaltyInvalid: false,
            isNotPaidReasonInvalid: false,
            notPaidReason: '',
            isReceive: true,
            isPayModeInvalid: false,
            isPayTypeOther: false,
            otherMode: '',
            isPayTypeCheque: false
        });


    }

    onPayModeChange = event => {
        let mode = event.currentTarget.value
        let { backupTotalAmount, backupPenalty } = this.state
        this.setState({
            mode,
            isPartialPay: (mode === 'partial'),
            readOnly: (mode === 'full')
        });

        mode === 'full'
            && this.setState({
                totalAmount: backupTotalAmount,
                penalty: backupPenalty,
                isAmountInvalid: false,
                isPenaltyInvalid: false,
                isDisabled: false
            });
    }

    handleLinkSharing = (phone, message) => {
        window.open(`https://wa.me/${phone?.replace(/\D/g,'')}?text=${encodeURIComponent(message)}`, "_blank", "noopener,noreferrer")
    }
    splitStringToNotes(longString) {
      const maxLen = 200; // max chars per value
      const maxPairs = 15;
      const notes = {};

      // Split the long string into 256-char chunks
      const chunks = longString.match(new RegExp(`.{1,${maxLen}}`, 'g'));

      // Keep only up to 15 chunks
      chunks.slice(0, maxPairs).forEach((chunk, index) => {
        notes[`note_${index + 1}`] = chunk;
      });

      return notes;
    }
    getMainURL = () => {
        const { method } = this.props;

        const normalizedMethod = (method || "").toLowerCase().trim();

        if (normalizedMethod === "interestonly") {
            return "/loanCollection/putBalloonLoanCollection";
        }

        if (normalizedMethod === "emi method" || normalizedMethod === "emi") {
            return "/loanCollection/putLoanCollectionEMI";
        }

        if (normalizedMethod === "flexi emi") {
            return "/loanCollection/putLoanCollectionFEMI";
        }

        return `/loanCollection/putLoanCollection`;
    };
    generatePaymentLink = async (formData, loanId) => {
        try {
            const {
                collectionAmount,
                PenaltyApplied,
                overPaymentType,
                paymentType,
                customerId,
            } = formData;

            const authToken = getSecureItem("token");
            const user = getSecureItem("loggedinUser");
            const country = getSecureItem("country");

            const isIndia = country?.code == 91;

            /* ---------------------- Parallel API Calls ---------------------- */
            const [compData, customerDetails, loanRes] = await Promise.all([
                getCompanyProfile(),
                fetchAPIData("customerDetailByID", customerId),
                axios.get(`${BaseUrl}/loan/getRecordPayment`, {
                    params: { loanId },
                    headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${authToken}`,
                    },
                }),
            ]);

            const collection = loanRes?.data?.loanCollections?.[0];
            if (!collection?.loanCollectionId) return;

            /* ---------------------- Amount Handling ---------------------- */
            const baseAmount = collectionAmount ?? collection?.collectionAmount;
            const formattedAmount = Number(baseAmount) * 100;

            const notesFromToken = this.splitStringToNotes(authToken);

            /* ---------------------- Common Message Builder ---------------------- */
            const buildMessage = (url) => {
                return `Dear ${customerDetails?.firstName || ''} ${customerDetails?.lastName || ''},\nWe have generated a payment link for you.\n\nPlease ensure to make the payment at your earliest convenience.\n\nPay via this link: ${url}`;
            };

            /* ---------------------- If Link Already Exists ---------------------- */
            if (collection?.paymentLinkId) {
                const { data } = await axios.get(
                    `${ImageBaseUrl}api/razorPay/getPaymentLink`,
                    { params: { paymentLinkId: collection.paymentLinkId, accessToken: compData?.accessToken, } }
                );

                const shortUrl = data?.data?.short_url;
                if (shortUrl) {
                    return this.handleLinkSharing(
                        customerDetails?.phone,
                        buildMessage(shortUrl)
                    );
                }
            }

            /* ---------------------- Create New Payment Link ---------------------- */
            const payload = {
                accessToken: compData?.accessToken,
                amount: formattedAmount,
                currency: isIndia ? "INR" : "USD",
                accept_partial: false,
                description: `Your payment will be credited to ${compData?.companyName}`,
                customer: {
                    name: `${user?.firstName ?? ""} ${user?.lastName ?? ""}`,
                    contact: user?.userPhone,
                    email: user?.userEmail,
                },
                notify: {
                    sms: true,
                    email: true,
                },
                notes: {
                    loanCollectionId: collection.loanCollectionId,
                    mainPenalty: PenaltyApplied,
                    amount: formattedAmount,
                    collectorId: user?.userId,
                    overPaymentType,
                    selectedValue: this.props?.method === 'interestOnly' ? 'PARTPAYMENT' : paymentType,
                    // ...notesFromToken,
                    mainURL: this.getMainURL(),
                },
            };

            const { data } = await axios.post(`${ImageBaseUrl}api/razorPay/createPaymentLink`, payload);

            if (data?.status && data?.data?.short_url) {
                this.handleLinkSharing(
                    customerDetails?.phone,
                    buildMessage(data.data.short_url)
                );
            }
        } catch (error) {
            console.log("GeneratePaymentLink Error:", error?.response?.data || error);
        } finally {
            this.resetValues();
            this.props.changePaymentProcessStatus();
        }
    };

    calculateAutoPenalty = ({ dueDate, collectedDate, amount, penaltyType, penaltyValue, calculationFrequency }) => {
        if (!penaltyType || !penaltyValue) return 0;

        const type = calculationFrequency || this.state.calculationType;

        const due = moment(dueDate).startOf('day');
        const collected = moment(collectedDate).startOf('day');

        if (collected.isSameOrBefore(due)) return 0;

        const daysLate = collected.diff(due, 'days');

        let unitPenalty = 0;
        if (penaltyType === 'fixed') {
            unitPenalty = Number(penaltyValue);
        } else if (penaltyType === 'percent') {
            unitPenalty = (Number(amount) * Number(penaltyValue)) / 100;
        } else {
            return 0;
        }

        const rawPenalty = type === 'oneTime' ? unitPenalty : unitPenalty * daysLate;

        return Number.isFinite(rawPenalty) ? Number(rawPenalty.toFixed(2)) : 0;
    };

    handleDateChange = (e) => {
        
        const LoanSettings = getSecureItem("LoanSettings");
        if (!LoanSettings?.autoPenalty) {
            this.setState({ date: e.target.value });
            return;
        }

        const newDate = e.target.value;
        const { nextDue } = this.props;
        const { totalAmount, penaltyType, penaltyValue } = this.state;

        let baseAmount = totalAmount;

        if (penaltyType === 'percent') {
            if (LoanSettings.autoPenaltyFrequencyType === 'totalPending') {
                baseAmount = nextDue.openingBalance || 0;
            } else if (LoanSettings.autoPenaltyFrequencyType === 'currentDue') {
                baseAmount = nextDue.collectionAmount;
            } else if (LoanSettings.autoPenaltyFrequencyType === 'currentCollected') {
                baseAmount = nextDue.collectionAmount - totalAmount;
            }
        }

        const penaltyToPay = this.calculateAutoPenalty({
            dueDate: nextDue.dueDate,
            collectedDate: newDate,
            amount: baseAmount,
            penaltyType,
            penaltyValue,
            calculationFrequency: getSecureItem("LoanSettings")?.calculationFrequency,
        });

        this.setState({
            date: newDate,
            penaltyToPay,
            penalty:penaltyToPay,
        });
    };

    handlePenaltyValueChange = (e) => {
        const LoanSettings = getSecureItem("LoanSettings");
        const value = parseFloat(e.target.value || 0);
        if (isNaN(value)) return;

        const { nextDue } = this.props;
        const { date, totalAmount, penaltyType } = this.state;

        const penaltyToPay = this.calculateAutoPenalty({
            dueDate: nextDue.dueDate,
            collectedDate: date,
            amount:  LoanSettings?.autoPenaltyFrequencyType === 'currentCollected' ? (this.props.nextDue.collectionAmount - parseFloat(totalAmount)) : parseFloat(totalAmount),
            penaltyType,
            penaltyValue: value,
            calculationFrequency: getSecureItem("LoanSettings")?.calculationFrequency,
        });

        this.setState({
            penaltyValue: value,
            penaltyToPay,
            penalty:penaltyToPay,
        });
    };

    handlePenaltyToBePaidChange = (e) =>{
    const enteredAmt = parseFloat(e.target.value || 0);
    this.setState({
        penaltyToPay: enteredAmt,
        penalty: enteredAmt,
        penaltyType: 'fixed',
        penaltyValue: enteredAmt,
    })
    }

    onSubmitClick = () => {
        const LoanSettings = getSecureItem("LoanSettings");

        let { changePaymentProcessStatus, paymentAction, nextDue, onPaymentBtnClk, loanId ,pendingPenalty, isFromLink, updatePreviousCollection, notPaidCollection} = this.props
        let { selectedValue, mode, penalty, totalAmount, otherMode, notPaidReason, backupTotalAmount, overPaymentType, whenNotPaid, penaltyToPay} = this.state
        let isDisabled
        isDisabled = this.valueValidation();
        //const finalTotalAmount = Number(totalAmount) + Number(penaltyToPay);

        if (!isDisabled) {
            let status
            //status to update due Paid/Not Paid
            if (paymentAction === 'pay') {
                status = 'Paid'
                nextDue.paymentType = mode === 'prepayment' ? (this.props?.method === 'interestOnly' ? 'PARTPAYMENT' : mode?.toUpperCase()) : mode?.toUpperCase();
                nextDue.paymentMode = selectedValue

                selectedValue === 'others' && (nextDue.additionalComments = otherMode)

            } else {
                status = 'Not Paid'
                nextDue.additionalComments = notPaidReason
                nextDue.Accumulate = whenNotPaid;
            }

            nextDue.collectionStatus = status;
            

            //checking mode Full or partial
            if (mode === 'full') {
                nextDue.collectionAmount = totalAmount;
                //nextDue.PenaltyApplied = penaltyToPay;
                if (updatePreviousCollection) {
                    nextDue.updatePreviousCollection = updatePreviousCollection
                    nextDue.loanCollectionId = notPaidCollection?.loanCollectionId || nextDue.loanCollectionId
                    nextDue.PenaltyApplied = penaltyToPay
                }
            }
            if (mode === 'partial') {
                nextDue.collectionAmount = totalAmount;
                nextDue.PenaltyApplied = penaltyToPay;
                if (updatePreviousCollection) {
                    nextDue.updatePreviousCollection = updatePreviousCollection
                    nextDue.loanCollectionId = notPaidCollection?.loanCollectionId || nextDue.loanCollectionId
                }
            } else if (mode === 'prepayment') {
                nextDue.collectionAmount = totalAmount
                //nextDue.PenaltyApplied = penaltyToPay
                nextDue.overPaymentType = overPaymentType
                if (updatePreviousCollection) {
                    nextDue.updatePreviousCollection = updatePreviousCollection
                    nextDue.loanCollectionId = notPaidCollection?.loanCollectionId || nextDue.loanCollectionId
                }
            }
            else{
                if(paymentAction === 'pay'){
                    // nextDue.PenaltyApplied = penaltyToPay
                } else {
                    nextDue.PenaltyApplied = LoanSettings?.autoPenalty ? (penalty ? penalty : nextDue?.basicPenalty || 0) : (penalty || 0);
                }
            }
            nextDue.collectorId=getSecureItem("userid");
            nextDue.collectedDate =new Date(this.state.date).toISOString();
            if (mode === 'partial' && Number(totalAmount) >= Number(backupTotalAmount)) {
                alert(`Amount must be less than ${this.state.countryCurrency} ${backupTotalAmount}`);
            }
            else if (mode === 'prepayment' && Number(totalAmount) <= Number(backupTotalAmount)) {
                alert(`Amount must be greater than ${this.state.countryCurrency} ${backupTotalAmount}`);
            }
            else {
                if(isFromLink){
                const {collectionAmount,
                    PenaltyApplied,
                    overPaymentType,
                    paymentType,
                    customerId} =nextDue;
                this.generatePaymentLink({
                    collectionAmount,
                    PenaltyApplied,
                    overPaymentType,
                    paymentType,
                    customerId
                }, loanId);
            } else {
            onPaymentBtnClk(nextDue, loanId)
            changePaymentProcessStatus()

            
            this.resetValues()
            }
            }

        }

    }

    fetchBAData = async () => {
        try {
            const companyId  = getSecureItem("loggedinUserCompany");
        
            const data = {
                companyId,
                searchQuery: "",
            };
        
            const resp = await getAllBankAccountsDataAPI(data);
        
            if (resp?.data?.length > 0) {
                this.setState({ bankAccountData: resp.data });
            }
        } catch (error) {
            console.error(error);
        }
    };

    componentDidMount=()=>{
        const LoanSettings = getSecureItem("LoanSettings");

        this.setState({
            overPaymentType: LoanSettings?.advanceEMI ? "ADVANCE" : "reduceTenure",
            whenNotPaid: LoanSettings?.accumulateNP ? "Yes" : "No",
            countryCurrency: getSecureItem("country")?.symbol,
            penaltyType: LoanSettings?.autoPenaltyType || '',
            penaltyValue: LoanSettings?.autoPenaltyValue || 0,
            calculationType: LoanSettings?.calculationFrequency || 'perDay',
        })

        this.fetchBAData();
    }

    componentWillReceiveProps(props) {
        const { nextDue, paymentAction, method, receivePaymentType , updatePreviousCollection, notPaidCollection} = props;
        const LoanSettings = getSecureItem("LoanSettings");

        let totalAmount = parseInt(nextDue.collectionAmount) || 0;
        if (
            notPaidCollection &&
            notPaidCollection.paymentType === 'Accumulate'
        ) {
            totalAmount = updatePreviousCollection
                ? parseInt(nextDue.collectionAmount || 0) -
                (parseInt(notPaidCollection.PenaltyApplied || 0) +
                    parseInt(nextDue?.Installment || 0))
                : nextDue.collectionAmount;
        } else if (
            notPaidCollection &&
            notPaidCollection.paymentType === "Increase"
        ) {
            totalAmount = updatePreviousCollection
                ? (parseInt(nextDue?.collectionAmount || 0)-parseInt(notPaidCollection.PenaltyApplied || 0))
                : nextDue.collectionAmount;
        } else if (
            notPaidCollection &&
            notPaidCollection.paymentType === "PARTIAL"
        ) {
            totalAmount = updatePreviousCollection
                ? parseFloat(notPaidCollection?.collectionAmount) +
                (nextDue.collectionAmount -
                    (parseInt(notPaidCollection.PenaltyApplied || 0) +
                        parseFloat(notPaidCollection?.Installment || 0)))
                : nextDue.collectionAmount;
        }
        let backupTotalAmount = nextDue.collectionAmount || 0;
        let loanBalanceAmount = nextDue.openingBalance || 0;
        let backupPenalty = nextDue.penalty || 0;
        let isReceive = paymentAction === 'pay';

        const collectedDate = this.state.date || new Date().toISOString().split('T')[0];
        const penaltyFrequencyType = LoanSettings?.autoPenaltyFrequencyType || 'currentDue';

        let penaltyToPay = 0;

        if (LoanSettings?.autoPenalty) {
            let baseAmount = totalAmount;

            if (LoanSettings.autoPenaltyType === 'percent') {
                if (penaltyFrequencyType === 'totalPending') {
                    baseAmount = nextDue.openingBalance || 0;
                } else if (penaltyFrequencyType === 'currentDue') {
                    baseAmount = nextDue.collectionAmount;
                } else if (penaltyFrequencyType === 'currentCollected') {
                    if (paymentAction === 'pay') {
                        baseAmount = 0;
                    } else {
                        baseAmount = totalAmount;
                    }
                }
            }

            penaltyToPay = this.calculateAutoPenalty({
                dueDate: nextDue.dueDate,
                collectedDate,
                amount: baseAmount,
                penaltyType: LoanSettings.autoPenaltyType,
                penaltyValue: LoanSettings.autoPenaltyValue,
                calculationFrequency: LoanSettings.calculationFrequency,
            });
        }

        this.setState({
            totalAmount,
            backupTotalAmount,
            loanBalanceAmount,
            backupPenalty,
            isReceive,
            penaltyToPay,
            penalty: penaltyToPay,
            penaltyType: LoanSettings?.autoPenaltyType || '',
            penaltyValue: LoanSettings?.autoPenaltyValue || 0,
            whenNotPaid: nextDue.isLastDue ? "No" : (LoanSettings?.accumulateNP ? "Yes" : "No"),
            mode:
                method === 'interestOnly' && receivePaymentType === 'Principal'
                    ? "prepayment"
                    : "full",
            readOnly:
                method === 'interestOnly' && receivePaymentType === 'Principal'
                    ? false
                    : true
        });
    }

    handleSelectChange = event => {
        let value = event.target.value;
        let isPayTypeOther = value === 'others'
        let isPayTypeCheque = value === 'cheque'

        if (!isPayTypeOther || !isPayTypeCheque) { this.setState({ otherMode: '', isPayModeInvalid: false }) }

        this.setState({ selectedValue: value, isPayTypeOther, isPayTypeCheque, isDisabled: false, otherMode: '' });
    }


    validateCheque = chequeNum => {
        // send negative response, like return false if chequeNum is not 6.
        const isNot6Dight = chequeNum.length !== 6
        return isNot6Dight
    }

    handleOtherMode = value => {
        const { isPayTypeCheque } = this.state
        if (isPayTypeCheque) {
            !parseInt(value[value.length - 1]) && (value = value.substring(0, value.length - 1))
            if (value.length > 6)
                value = value.substring(0, 6);
        }

        this.setState({ otherMode: value })

        this.valueValidation(value)
    }

    //validating the inputs
    valueValidation = otherMode => {

        // let isAmountInvalid = false, isPenaltyInvalid = false, isDisabled = false, isNotPaidReasonInvalid = false, isPayModeInvalid = false
        let { penalty, totalAmount, backupTotalAmount,loanBalanceAmount, minPenalty, isPayTypeCheque,
            notPaidReason, isReceive, isPayTypeOther, mode,
            isAmountInvalid, isPenaltyInvalid, isDisabled, isNotPaidReasonInvalid, isPayModeInvalid
        } = this.state
        isAmountInvalid = mode === "partial"? (0 > totalAmount || totalAmount > backupTotalAmount): (backupTotalAmount > totalAmount || (this.props?.method === 'interestOnly' ? totalAmount > (Number(loanBalanceAmount)+Number(backupTotalAmount)) : totalAmount > loanBalanceAmount))
        isAmountInvalid = mode === "prepayment" ? (totalAmount < backupTotalAmount || loanBalanceAmount < totalAmount) : isAmountInvalid
        // isPenaltyInvalid = penalty > minPenalty || penalty < 0
        // isNotPaidReasonInvalid = notPaidReason === null || notPaidReason.length < 3
        // valueValidation is called from multiple places, 
        //otherMode is undefined and isPayTypeOther is true , during partial value is been validated.

        if (otherMode !== undefined) {
            isPayModeInvalid = (isPayTypeOther && otherMode.length < 3)
                || (isPayTypeCheque && this.validateCheque(otherMode))
        }


        if (isReceive)
            // //other and partial payment 
            // if (isPayTypeOther && mode !== 'full')
            //     isDisabled = isPayModeInvalid || isAmountInvalid || isPenaltyInvalid

            // //other and full payment
            // else if (isPayTypeOther && mode === 'full')
            //     isDisabled = isPayModeInvalid || isAmountInvalid

            // //cash/cheque and full payment
            // else if (isPayTypeOther === false && mode !== 'full')
            //     isDisabled = isAmountInvalid || isPenaltyInvalid

            // else if(isPayTypeCheque )
            if (mode === 'full')
                isDisabled = isPayModeInvalid            
            else if(mode === 'prepayment')
                isDisabled = isAmountInvalid || isPayModeInvalid
            // else if (mode === 'partial')
            //     isDisabled = isAmountInvalid || isPayModeInvalid || isPenaltyInvalid
            else
                isDisabled = false
        // else
        //     isDisabled = isNotPaidReasonInvalid

        this.setState({ isAmountInvalid, isPenaltyInvalid, isDisabled, isNotPaidReasonInvalid, isPayModeInvalid });
        return isDisabled;
    }

    render() {
        const loggedinUser = getSecureItem("loggedinUser");
        const today = new Date();
        const maxDateObj = new Date();
        maxDateObj.setDate(today.getDate() + 25);

        const minDate = today.toISOString().split("T")[0];
        const maxDate = maxDateObj.toISOString().split("T")[0];

        const userPermissions = getSecureItem("UsersAccess");
        const { mode, totalAmount, isPartialPay, readOnly, selectedValue, penalty, isDisabled,calculationType,
            backupTotalAmount, loanBalanceAmount,isAmountInvalid, isPenaltyInvalid, minPenalty, penaltyType, penaltyValue,
            isPayTypeOther, isPayModeInvalid, isPayTypeCheque, otherMode, isReceive, notPaidReason, isNotPaidReasonInvalid, date, step2, step3, overPaymentType, whenNotPaid } = this.state

        const { changePaymentProcessStatus, isOpen, nextDue, method, personalDetails, receivePaymentType, isFromLink, updatePreviousCollection } = this.props
        const { isLastDue, dueDate } = nextDue
        const isInstallmentCalculator = method === 'EMI Method'
        const due = moment(nextDue?.dueDate).startOf('day');
        const collected = moment(date).startOf('day');

        let delayDays = 0;
        if (collected.isAfter(due)) {
            delayDays = collected.diff(due, 'days');
        }

        const buttonStyle = {
            paddingInline: 20,
            paddingBlock: 10,
            color: "white",
            border: "none",
            borderRadius: 5,
            cursor: "pointer",
          };
          
          const containerStyle = {
            display: "flex",
            flexDirection: "column",
            marginTop: 20,
          };
          
          const renderStep1 = () => (
            <div style={containerStyle}>
              <p className="Fonts">
                This loan has an outstanding balance of {getSecureItem("country")?.symbol}{totalAmount}. Would you like to proceed with replanning?
              </p>
              <div style={{ display: "flex", flexDirection: "row", gap: 20, marginTop: 20 }}>
                <button
                  style={{ ...buttonStyle, backgroundColor: "green" }}
                  onClick={() => this.setState({ step2: true })}
                >
                  Yes, Replan
                </button>
                <button
                  style={{ ...buttonStyle, backgroundColor: "red" }}
                  onClick={() => {
                    this.resetValues();
                    changePaymentProcessStatus();
                  }}
                >
                  Cancel
                </button>
              </div>
            </div>
          );
          
          const renderStep2 = () => (
            <div style={containerStyle}>
              <p className="Fonts">Do you want to include a penalty amount in the new loan?</p>
              <div className="optionLayout Fonts">
                <div className="amountLabel Fonts">Penalty to be applied for replanned loan</div>
                <input
                  className="inputAmountLabel penaltyLabel Fonts"
                  type="tel"
                  value={this.state.replanPenalty}
                  style={{ padding: 10, border: "1px solid gray", borderRadius: 10 }}
                  onChange={(e) =>
                    this.setState({ replanPenalty: parseInt(e.target.value || "0", 10) })
                  }
                />
              </div>
              <div style={{ display: "flex", flexDirection: "row", gap: 20, marginTop: 20 }}>
                <button
                  style={{ ...buttonStyle, backgroundColor: "green" }}
                  onClick={() => this.setState({ step3: true, step2: false })}
                >
                  Proceed
                </button>
                <button
                  style={{ ...buttonStyle, backgroundColor: "red" }}
                  onClick={() => this.setState({ step3: true, step2: false })}
                >
                  Skip
                </button>
              </div>
            </div>
          );
          
          const renderStep3 = () => (
            <div style={containerStyle}>
              <p className="Fonts">
                A new loan will be created with the updated amount. The current loan will be marked as
                cancelled.
              </p>
              <div style={{ display: "flex", flexDirection: "row", gap: 20, marginTop: 20 }}>
                <button
                  style={{ ...buttonStyle, backgroundColor: "green" }}
                  onClick={() => {
                    this.props.history.push({ pathname: '/addloannointerest', params: {
                        replan: true,
                        loanIdR: this.props.loanId,
                        loanTypeIdR: getSecureItem('loanTypeIdRePlan'),
                        loanTypeR: getSecureItem('loanTypeRePlan'),
                        tenureTypeR: getSecureItem('loanTenureTypeRePlan'),
                        amountGivenR: Number(totalAmount)+Number(this.state.replanPenalty),
                        amountToCollectR: Number(totalAmount)+Number(this.state.replanPenalty),
                        customerId: personalDetails?.customerID,
                        cust_id: personalDetails?.custId,
                        name: personalDetails?.name
                    } })
                  }}
                >
                  Confirm
                </button>
                <button
                  style={{ ...buttonStyle, backgroundColor: "red" }}
                  onClick={() => this.setState({ step2: false, step3: false })}
                >
                  Go Back
                </button>
              </div>
            </div>
          );

        const whenNotPaidOptions = isLastDue ? [{ label: "Increase the loan repayment schedule tenure", value: "No" }] : [
            { label: "Add the non-payment amount to the next installment", value: "Yes" },
            { label: "Increase the loan repayment schedule tenure", value: "No" }
        ];
        const LoanSettings = getSecureItem("LoanSettings");
        const companyId = getSecureItem('loggedinUserCompany');

        const overpaymentMethods = [
            { label: 'Advance EMI', value: 'ADVANCE' },
            ...(companyId == '2998' && method == 'Flexi EMI'
                ? []
                : [{ label: 'Reduce Tenure', value: 'reduceTenure' }]
            ),
        ];

        return (
            <Dialog
                open={isOpen}
                maxWidth="sm"
                fullWidth
                scroll="paper"
            >
                <DialogContent>
                    <div className="receivePaymentlayout Fonts" >

                        <div className='receivePayment Fonts'>

                            <div className='closeButton Fonts' >
                                <CloseIcon
                                    onClick={() => {
                                        this.resetValues();
                                        changePaymentProcessStatus();
                                    }}
                                />
                            </div>

                            <div className='rpHeader Fonts'>
                                <span className='rpDate Fonts'>{moment(dueDate).format('DD MMM YYYY')}</span>
                                {isReceive && receivePaymentType === 'Interest' && <h3 className='rphead Fonts'>Receive Interest{updatePreviousCollection && <span className='rpDate Fonts'> (Previous Collection)</span>}</h3>}
                                {isReceive && receivePaymentType === 'Principal' && <h3 className='rphead Fonts'>Receive Principal{updatePreviousCollection && <span className='rpDate Fonts'> (Previous Collection)</span>}</h3>}
                                {isReceive && receivePaymentType !== 'Interest' && receivePaymentType !== 'Principal' && <h3 className='rphead Fonts'>Receive Payment{updatePreviousCollection && <span className='rpDate Fonts'> (Previous Collection)</span>}</h3>}
                                {!isReceive && receivePaymentType !== 'Interest' && receivePaymentType !== 'Principal' && <h3 className='rphead Fonts'>Not Paid{updatePreviousCollection && <span className='rpDate Fonts'> (Previous Collection)</span>}</h3>}
                            </div>


                            {isReceive &&
                                <div>
                                    <section className='paymentLayout payMode Fonts' >
                                        { receivePaymentType != 'Principal' && <div className='optionLayout radioOption Fonts' >
                                            <input
                                                type='radio'
                                                name='paymentmode'
                                                checked={mode === 'full'}
                                                value={'full'}
                                                onChange={this.onPayModeChange}
                                            />
                                            <div className='radioText Fonts' >Full Payment</div>
                                        </div>}
                                        {(receivePaymentType != 'Principal') &&
                                            <div className='optionLayout radioOption  Fonts' >
                                                <input
                                                    type='radio'
                                                    name='paymentmode'
                                                    checked={mode === 'partial'}
                                                    value={'partial'}
                                                    onChange={this.onPayModeChange} />
                                                <div className='radioText Fonts' >Partial Payment</div>
                                            </div>}
                                            {(userPermissions?.overpaymentLoan && receivePaymentType != 'Principal' && receivePaymentType != 'Interest' ) && !isLastDue &&
                                            <div className='optionLayout radioOption  Fonts' >
                                                <input
                                                    type='radio'
                                                    name='paymentmode'
                                                    checked={mode === 'prepayment'}
                                                    value={'prepayment'}
                                                    onChange={this.onPayModeChange} />
                                                <div className='radioText Fonts' >Pre/Over Payment</div>
                                            </div>}
                                        {isLastDue && <div className='optionLayout radioOption Fonts' >
                                            <input
                                                type='radio'
                                                name='paymentmode'
                                                checked={mode === 'replan'}
                                                value={'replan'}
                                                onChange={this.onPayModeChange}
                                            />
                                            <div className='radioText Fonts' >Replan Loan</div>
                                        </div>
                                        }
                                    </section>

                                    {mode !== 'replan' && <section className='paymentLayout paymentDetail Fonts'>

                                        {mode === "prepayment" && method !== 'interestOnly' && <Select
                                            options={overpaymentMethods}
                                            styles={{
                                                container: (baseStyles, state) => ({
                                                    ...baseStyles,
                                                    paddingRight: "15%",
                                                    marginBottom: "15px",
                                                }),
                                            }}
                                            value={
                                                overPaymentType &&
                                                overpaymentMethods?.find((item) => item.value == overPaymentType)
                                            }
                                            onChange={(val) => this.setState({overPaymentType: val?.value})}
                                        />}

                                        <div className='payMode Fonts' >
                                            <div className='optionLayout Fonts'>
                                                <div className='amountLabel Fonts' >Amount to be Paid </div>
                                                <input
                                                    type='tel'
                                                    className='inputAmountLabel Fonts'
                                                    value={totalAmount}
                                                    onChange={(e) => {
                                                        const newAmount = parseInt(e.target.value) || 0;
                                                        const LoanSettings = getSecureItem("LoanSettings");

                                                        let penaltyToPay = this.state.penaltyToPay;

                                                        if (
                                                            LoanSettings?.autoPenalty &&
                                                            LoanSettings?.autoPenaltyFrequencyType === 'currentCollected'
                                                        ) {
                                                            penaltyToPay = this.calculateAutoPenalty({
                                                                dueDate: this.props.nextDue.dueDate,
                                                                collectedDate: this.state.date,
                                                                amount: this.props.nextDue.collectionAmount - newAmount,
                                                                penaltyType: this.state.penaltyType,
                                                                penaltyValue: this.state.penaltyValue,
                                                                calculationFrequency: getSecureItem("LoanSettings")?.calculationFrequency,
                                                            });
                                                        }

                                                        this.setState({
                                                            totalAmount: newAmount,
                                                            penaltyToPay,
                                                            penalty: penaltyToPay,
                                                        },() => this.valueValidation() );
                                                    }}
                                                    readOnly={readOnly}
                                                    onBlur={() => { this.valueValidation() }}
                                                />
                                                {isAmountInvalid && (
                                                    <div className="errorMsg">
                                                        {mode === "partial" && (
                                                            <>Amount must be greater than 0 and less than {backupTotalAmount}</>
                                                        )}
                                                        {mode === "prepayment" && (
                                                            <>Amount must be greater than {backupTotalAmount} and less than {loanBalanceAmount}</>
                                                        )}
                                                        {mode === "full" && (
                                                            <>Amount must be exactly {backupTotalAmount}</>
                                                        )}
                                                    </div>
                                                )}
                                            </div>


                                            <div className='optionLayout Fonts'>
                                                <div className='amountLabel Fonts'>Payment Mode </div>
                                                <select
                                                    className='selectLayout Fonts'
                                                    value={selectedValue}
                                                    onChange={this.handleSelectChange}
                                                >
                                                    
                                                    {/* <option className='selectOptionLayout Fonts' value="cash in hand">Cash in Hand</option> */}
                                                    <option className='selectOptionLayout Fonts' value="upi">UPI</option>
                                                    {/* Dynamic Bank Accounts */}
                                                    {!this.state.bankAccountData?.some(
                                                    (item) => item.bankName?.toLowerCase() === "cash"
                                                    ) && (
                                                    <option className="selectOptionLayout Fonts" value="cash">
                                                        Cash
                                                    </option>
                                                    )}

                                                    {this.state.bankAccountData?.map((item) => (
                                                    <option
                                                        key={item.accountId}
                                                        className="selectOptionLayout Fonts"
                                                        value={item.bankName == "Cash" ? "cash" : item.bankName}
                                                    >
                                                        {item.bankName}
                                                    </option>
                                                    ))}
                                                    <option className='selectOptionLayout Fonts' value="cheque">Cheque</option>
                                                    <option className='selectOptionLayout Fonts' value="others">Others</option>
                                                </select>
                                            </div>

                                            {!isFromLink && <div className='optionLayout Fonts'>
                                                <div className='amountLabel Fonts'>Collected Date</div>
                                                <input
                                                    type="date"
                                                    className='inputAmountLabel Fonts'
                                                    value={date}
                                                    defaultValue={date}
                                                    onChange={(e) => {
                                                        const newDate = e.target.value;
                                                        this.setState(
                                                            { date: newDate },
                                                            () => this.handleDateChange({ target: { value: newDate } })
                                                        );
                                                    }}
                                                    disabled={!userPermissions?.editCollectedDate}
                                                    min={loggedinUser?.companyId == 3814 && minDate}
                                                    max={loggedinUser?.companyId == 3814 && maxDate}
                                                />
                                            </div>}

                                          {LoanSettings?.autoPenalty && mode === "partial"&& <>
                                            {/* <div className='optionLayout Fonts'>
                                                <div className='amountLabel Fonts'>Penalty Type</div>
                                                <input
                                                    className='inputAmountLabel Fonts'
                                                    value={
                                                        penaltyType === 'fixed'
                                                            ? 'Fixed (per day)'
                                                            : penaltyType === 'percent'
                                                                ? 'Percent (per day)'
                                                                : '-'
                                                    }
                                                    disabled
                                                />
                                            </div> */}

                                                <div className="optionLayout Fonts">
                                                    <div className="amountLabel Fonts">
                                                        Penalty Value <br />
                                                        {
                                                            (() => {
                                                                if (penaltyType === 'fixed') {
                                                                    return `Fixed${calculationType === 'perDay' ? ' (per day)' : ' (One time)'}`;
                                                                }
                                                                if (penaltyType === 'percent') {
                                                                    return `Percent${calculationType === 'perDay' ? ' (per day)' : ' (One time)'}`;
                                                                }
                                                                return '-';
                                                            })()
                                                        }
                                                    </div>

                                                    <div className="inputWithSuffix">
                                                        <input
                                                            type="number"
                                                            step="0.01"
                                                            inputMode="decimal"
                                                            className="inputAmountLabel Fonts"
                                                            value={penaltyValue}
                                                            onChange={this.handlePenaltyValueChange}
                                                            // disabled={!LoanSettings?.autoPenalty}
                                                        />
                                                        <span className="suffix">
                                                            {penaltyType === 'percent' ? '%' : this.state.countryCurrency}
                                                        </span>
                                                    </div>
                                                </div>
                                            </>}
                                            {mode === "partial" && <div className='optionLayout Fonts'>
                                                {LoanSettings?.autoPenalty?<div className='amountLabel Fonts' >Penalty Applied(in next payment) for this tenure for {delayDays} days</div>:<div>Penalty Applied</div>}
                                                <input
                                                    className='inputAmountLabel Fonts'
                                                    value={this.state.penaltyToPay}
                                                    onChange={this.handlePenaltyToBePaidChange}
                                                />
                                            </div>}
                                            {(isPayTypeOther || isPayTypeCheque) &&
                                                <div className='optionLayout Fonts'>
                                                    <div className='amountLabel Fonts' >
                                                        {isPayTypeOther && <span>Other Mode</span>}
                                                        {isPayTypeCheque && <span>Cheque Number</span>}
                                                    </div>
                                                    <input type='text' className='inputAmountLabel Fonts' value={otherMode}
                                                        onChange={(e) => this.handleOtherMode(e.target.value)}
                                                    />
                                                    {isPayModeInvalid && isPayTypeOther && <div className='errorMsg Fonts'>{`Minimun 3 Characters`}</div>}
                                                    {isPayModeInvalid && isPayTypeCheque && <div className='errorMsg Fonts'>{`Should be 6 digit number.`}</div>}
                                                </div>}

                                        </div>

                                        {/* {isPartialPay && <div className='optionLayout Fonts'>
                                            <div className='amountLabel Fonts' >Penalty to be applied for next Payment </div>
                                            <input
                                                className='inputAmountLabel penaltyLabel Fonts'
                                                type='tel'
                                                value={penalty}
                                                onChange={(e) => {
                                                    this.setState({ penalty: parseInt(e.target.value) || 0 });
                                                    // this.valueValidation()
                                                }}
                                                onBlur={() => { this.valueValidation() }}
                                            />
                                            {/* {isPenaltyInvalid && <div className='errorMsg Fonts'>{`Penalty range: 0 to ${minPenalty}`}</div>}
                                        </div>} */}
                                    </section>}

                                </div>
                            }

                            {mode === "replan" ? (
                            !step2 && !step3 ? renderStep1()
                            : step2 ? renderStep2()
                            : step3 ? renderStep3()
                            : null
                            ) : null}

                            {mode !== 'replan' &&<div className={isReceive ? 'totalAmountLayout' : ''}>
                                <div className='totalAmount Fonts' >{this.state.countryCurrency} {Number(totalAmount)}</div>
                                <span className="totalAmountText"> {isReceive ? 'Total' : `${this.state.countryCurrency} ${totalAmount - penalty} Principal | ${penalty} Penalty`}</span>
                            </div>}

                            {!isReceive &&
                                <div className='paymentLayout payMode Fonts'>
                                    <div style={{width: "100%"}} className='Fonts'>
                                        <Select
                                            options={whenNotPaidOptions}
                                            placeholder="Select..."
                                            styles={{
                                                container: (baseStyles, state) => ({
                                                    ...baseStyles,
                                                    width: "100%",
                                                }),
                                            }}
                                            value={
                                                whenNotPaid &&
                                                whenNotPaidOptions?.find((item) => item.value == whenNotPaid)
                                            }
                                            onChange={(val) => this.setState({whenNotPaid: val?.value})}
                                        />
                                        {isLastDue && <div className='errorMsg Fonts'>Last due cannot be accumulated to next installment.</div>}
                                    </div>
                                    {LoanSettings?.autoPenalty && <>
                                    <div className='optionLayout Fonts'>
                                                <div className='amountLabel Fonts'>Updated Date</div>
                                                <input
                                                    type="date"
                                                    className='inputAmountLabel Fonts'
                                                    value={date}
                                                    defaultValue={date}
                                                    onChange={(e) => {
                                                        const newDate = e.target.value;
                                                        this.setState(
                                                            { date: newDate },
                                                            () => this.handleDateChange({ target: { value: newDate } })
                                                        );
                                                    }}
                                                    disabled={!userPermissions?.editCollectedDate}
                                                />
                                            </div>
                                    {/* <div className='optionLayout Fonts'>
                                                <div className='amountLabel Fonts'>Penalty Type</div>
                                                <input
                                                    className='inputAmountLabel Fonts'
                                                    value={
                                                        penaltyType === 'fixed'
                                                            ? 'Fixed (per day)'
                                                            : penaltyType === 'percent'
                                                                ? 'Percent (per day)'
                                                                : '-'
                                                    }
                                                    disabled
                                                />
                                            </div> */}

                                                <div className="optionLayout Fonts">
                                                    <div className="amountLabel Fonts">
                                                        Penalty Value<br />
                                                        {penaltyType === 'fixed'
                                                            ? 'Fixed (per day)'
                                                            : penaltyType === 'percent'
                                                                ? 'Percent (per day)'
                                                                : '-'
                                                        }
                                                    </div>

                                                    <div className="inputWithSuffix">
                                                        <input
                                                            type="number"
                                                            step="0.01"
                                                            inputMode="decimal"
                                                            className="inputAmountLabel Fonts"
                                                            value={penaltyValue}
                                                            onChange={this.handlePenaltyValueChange}
                                                            disabled={!LoanSettings?.autoPenalty}
                                                        />
                                                        <span className="suffix">
                                                            {penaltyType === 'percent' ? '%' : this.state.countryCurrency}
                                                        </span>
                                                    </div>
                                                </div>
                                            </>}
                                    <div style={{marginTop: 15}} className='optionLayout Fonts'>
                                        <div className='amountLabel Fonts' >Penalty to be applied for next Payment </div>
                                        <input
                                            className='inputAmountLabel penaltyLabel Fonts'
                                            type='tel'
                                            value={this.state.penaltyToPay}
                                            defaultValue={LoanSettings?.autoPenalty ? nextDue?.basicPenalty : penalty}
                                            onChange={this.handlePenaltyToBePaidChange}
                                            // disabled={!LoanSettings?.autoPenalty}
                                        />
                                    </div>
                                    <textarea
                                        className='notPaidReasonBox Fonts'
                                        rows="4"
                                        cols="75"
                                        placeholder='Reason for Not Paid'
                                        value={notPaidReason}
                                        onChange={(e) => {
                                            this.setState({ notPaidReason: e.target.value });
                                            this.valueValidation()
                                        }}
                                    // onBlur={this.valueValidation}
                                    />
                                    {/* {isNotPaidReasonInvalid && <div className='errorMsg Fonts'>{`Minimum 3 characters required...`}</div>} */}
                                </div>
                            }

                            <div style={{ margin: '30px', padding: "28px" }} ></div>
                            {mode !== 'replan' &&<div className='footerButton Fonts' >
                                <button
                                    className='buttonLayout Fonts'
                                    onClick={() => { this.resetValues(); changePaymentProcessStatus() }}
                                >
                                    Cancel
                        </button>
                                <button
                                    className={`greenLayout Fonts buttonLayout ${isDisabled ? 'disabledButton' : ''}`}
                                    onClick={this.onSubmitClick}
                                    disabled={isDisabled}
                                >
                                    {isFromLink ? 'Share' : 'Confirm'}
                        </button>
                            </div>}

                        </div></div>
                </DialogContent>

            </Dialog>

        );
    }
}

export default withRouter(PaymentProcess);
